import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EirButton from '../eir-button/EirButton';

class EirErrorModal extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            modal: false,
        }
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal,
        })

        this.props.toggleError(!this.state.modal)
    }

    componentDidMount() {
        this.setState({
            modal: this.props.errorModal
        })
    }

    render() {
        const { modal } = this.state;
        const { toggle } = this;
        return (
            <div>
                <Modal isOpen={ modal || this.props.errorModal } centered={true} toggle={toggle}>
                    <ModalHeader toggle={toggle}>Error</ModalHeader>   
                    <ModalBody className='text-center'>
                        An Error Occured. <br />
                        Please try again later.
                    </ModalBody>
                    <ModalFooter>
                        <EirButton type='button' className='webmail-btn' text='Close' onClick={toggle} />
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default EirErrorModal;
